import CoreuiController from "../lib/coreui-controller"
import Sidebar from "../coreui/sidebar"

export default class CoreuiSidebarController extends CoreuiController {
  static Component = Sidebar
}
